import { apiClient } from '../_helpers';

export const unitService = {
  getAll,
  getSelectList,
  getById,
  searchUnits,
  addUnit,
  updateUnit,
  deleteUnit
};

function getAll() {
  return apiClient('units/')
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}

function getSelectList() {
  return apiClient('units/selectlist')
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}

function getById(id) {
  return apiClient('units/')
  .get(`${id}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function searchUnits(qry) {
  return apiClient(`units?searchQuery=${qry}`)
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function addUnit(newUnit) {
  return apiClient('units/')
  .post('',`${JSON.stringify(newUnit)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function updateUnit(unit) {
  return apiClient(`units/${unit.id}`)
  .put('',`${JSON.stringify(unit)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function deleteUnit(unit) {
  return apiClient(`units/${unit}`)
  .delete()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}